<template>
	<div class="hiq-search-app">
		<search-header></search-header>
		<category-filter></category-filter>
		<search-info></search-info>
		<search-result></search-result>
		<loader></loader>
		<load-more></load-more>
	</div>
</template>

<script>
import SearchHeader from './components/SearchHeader.vue';
import CategoryFilter from './components/CategoryFilter.vue';
import SearchInfo from './components/SearchInfo.vue';
import SearchResult from './components/SearchResult.vue';
import Loader from './components/Loader.vue';
import LoadMore from './components/LoadMore.vue'

export default {
	name: 'search-app',
	components: {
		SearchHeader,
		CategoryFilter,
		SearchInfo,
		SearchResult,
		Loader,
		LoadMore,
	}
}
</script>
